export default __webpack_public_path__ + "9bb57790e28745694485f3af8dea31a1.svg";